import { postData } from '@/services/api.service';
import { routes } from '@/utils/routes/routes';
import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router';
import Spinner from './Components/spinner';

const CommonHeaderPage = () => {
  const { header } = useParams();
  const [headerData, setHeaderData] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      const payload = {
        slug: header,
      };
      try {
        const response = await postData('pages', payload);
        if (response.status === 200 || response.status === 201) {
          setHeaderData(response?.data?.data);
        }
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [header]);
  return (
    <div>
      {loading ? (
        <Spinner />
      ) : (
        <>
          {/* Breadcrumb */}
          {/* <div className="breadcrumb-section mb-3">
            <div className="container">
              <div className="row">
                <div className="col">
                  <h1 className="page-title">
                    {headerData?.page_name || headerData?.page?.page_name}
                  </h1>
                  <ul>
                    <li>
                      <Link to={routes.home}>Dashboard</Link>
                    </li>
                    <li className="active">
                      {' '}
                      {headerData?.page_name || headerData?.page?.page_name}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div> */}
          <section className="my-account-section mt-3">
            <div className="container">
              <div className="row">
                {headerData?.slug == 'faq' ||
                headerData?.page?.slug == 'faq' ? (
                  <>
                    <div className="accordion" id="accordionExample">
                      {headerData?.faq?.map((data: any, index: number) => (
                        <div className="accordion-item" key={index}>
                          <h2
                            className="accordion-header"
                            id={`heading-${index}`}
                          >
                            <button
                              className={`accordion-button ${index === 0 ? '' : 'collapsed'}`}
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target={`#collapse-${index}`}
                              aria-expanded={index === 0 ? 'true' : 'false'}
                              aria-controls={`collapse-${index}`}
                            >
                              {data?.question}
                            </button>
                          </h2>
                          <div
                            id={`collapse-${index}`}
                            className={`accordion-collapse collapse ${index === 0 ? 'show' : ''}`}
                            aria-labelledby={`heading-${index}`}
                            data-bs-parent="#accordionExample"
                          >
                            <div className="accordion-body">{data?.answer}</div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </>
                ) : (
                  <span
                    dangerouslySetInnerHTML={{
                      __html: headerData?.description,
                    }}
                  />
                )}
              </div>
            </div>
          </section>
        </>
      )}
    </div>
  );
};

export default CommonHeaderPage;
